import { Lab } from "@/Common/Api/Labs/Dto/Responses/Lab";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { GeographicInfoCountry } from "../Localization/GeographicInfoCountry";
import { GeographicInfoState } from "../Localization/GeographicInfoState";

class LabFacilityModel {
    public Model: Lab;

    public isValidPhone: boolean;
    public phoneMasked: string;

    public isFaxValid: boolean;
    public faxMasked: string;

    public isEmailValid: boolean;
    public isFaxPublicValid: boolean;
    public faxPublicMask: string;

    public isPhonePublicValid: boolean;
    public phonePublicMask: string;

    public isPostalCodeValid: boolean;

    public provinceMyleLookupId: string;
    public countryMyleLookupId: string;

    public countryMyleLookupCode: string;

    constructor(model: Lab) {
        if (model == null)
            this.Model = new Lab();
        else
            this.Model = model;

        this.init();
    }

    public init(): void {
        let model = this.Model;
        // Country
        if (!IsNullOrWhiteSpace(model.Country) || model.Country.length > 0)
            this.countryMyleLookupId = cacheStore.FindLookupByLookupCode(cacheStore.GetCountryLookupById_medfarDictionaries(model.Country)).LookupID;
        else {
            this.countryMyleLookupId = cacheStore.GetDefaultCountryForActiveSite().LookupID;
            model.Country = this.convertTodictionaryId(this.countryMyleLookupId).Id;
        }

        // Province
        if (!IsNullOrWhiteSpace(model.Province) || model.Province.length > 0) {
            let provinceGeoInfo = cacheStore.GetStateMedfarDictionariesById_MedfarDic(model.Province);
            let provinceMyleLookup = cacheStore.FindLookupByLookupCode(provinceGeoInfo.Myle_LookupCode);
            this.provinceMyleLookupId = provinceMyleLookup.LookupID;
        }
        else if (IsNullOrWhiteSpace(model.Province)) {
            this.provinceMyleLookupId = cacheStore.GetDefaultRegionForActiveSite().LookupID;
            model.Province = this.convertProvinceTodictionaryId(this.provinceMyleLookupId).Id;
        }

        this.countryMyleLookupCode = cacheStore.FindLookupByLookupCode(cacheStore.GetCountryLookupById_medfarDictionaries(model.Country)).LookupCode;

        this.SetFax(this.Model.Fax, MyleHelper.FormatPhone(this.Model.Fax, this.countryMyleLookupCode));
        this.SetPhone(this.Model.Phone, MyleHelper.FormatPhone(this.Model.Phone, this.countryMyleLookupCode));
        this.SetPublicFax(this.Model.FaxPublic, MyleHelper.FormatPhone(this.Model.FaxPublic, this.countryMyleLookupCode));
        this.SetPublicPhone(this.Model.PhonePublic, MyleHelper.FormatPhone(this.Model.PhonePublic, this.countryMyleLookupCode));
        this.emailValidation(this.Model.Email);
    }

    public Clone(): LabFacilityModel {
        return new LabFacilityModel(JSON.parse(JSON.stringify(this.Model)));
    }

    public GetFormattedPhone(): string {
        return this.Model.Phone == null ? "" : MyleHelper.FormatPhone(this.Model.Phone, this.countryMyleLookupCode);
    }

    public GetFormattedPublicPhone(): string {
        return this.Model.PhonePublic == null ? "" : MyleHelper.FormatPhone(this.Model.PhonePublic, this.countryMyleLookupCode);
    }

    public GetFormattedFax(): string {
        return this.Model.Fax == null ? "" : MyleHelper.FormatPhone(this.Model.Fax, this.countryMyleLookupCode);
    }

    public GetpublicFax(): string {
        return this.Model.FaxPublic == null ? "" : MyleHelper.FormatPhone(this.Model.FaxPublic, this.countryMyleLookupCode);
    }

    public SetProvinceByMyleLookupId(newValue: string): void {
        this.Model.Province = this.convertProvinceTodictionaryId(newValue).Id;
        this.provinceMyleLookupId = newValue;
        let provinceLookup = cacheStore.GetLookupById(newValue);
        if (provinceLookup) {
            if (provinceLookup.LookupCode != "CanadaState_QC")
                this.Model.RegionNumber = "";
        }
    }

    public SetProvinceByDictionaryId(newValue: string): void {
        this.Model.Province = cacheStore.FindLookupByLookupCode(cacheStore.GetStateMedfarDictionariesById_MedfarDic(newValue).Myle_LookupCode).LookupID;
        this.provinceMyleLookupId = newValue;
    }

    public convertProvinceTodictionaryId(value: string): GeographicInfoState {
        return cacheStore.GetStateMedfarDictionariesByLookUpType((cacheStore.GetLookupById(value).LookupCode));
    }

    public SetDefaultProvince(): void {
        if (this.countryMyleLookupId == cacheStore.GetDefaultCountryForActiveSite().LookupCode)
            this.SetProvinceByMyleLookupId(cacheStore.GetDefaultRegionForActiveSite().LookupID);
        else {
            let regionList = cacheStore.GetCountryRegionLookups(cacheStore.GetLookupById(this.countryMyleLookupId));
            this.SetProvinceByMyleLookupId(regionList[0].LookupID);
        }
    }

    public convertTodictionaryId(value: string): GeographicInfoCountry {
        return cacheStore.GetCountryMedfarDictionariesByLookUpType((cacheStore.GetLookupById(value).LookupCode));
    }

    public SetCountryByMyleLookupId(newValue: string): void {
        this.Model.Country = this.convertTodictionaryId(newValue).Id;
        this.countryMyleLookupId = newValue;
    }

    public SetCountryByDictionaryId(newValue: string): void {
        this.Model.Country = cacheStore.FindLookupByLookupCode(cacheStore.GetCountryLookupById_medfarDictionaries(newValue)).LookupID;
        this.countryMyleLookupId = newValue;
    }

    public SetPhone(newValue: string, newMaskedValue: string): void {
        // fetch Phon mask info
        let phoneValidationRule = this.GetPhoneValidationRule();
        let validationRegex: string = phoneValidationRule ? phoneValidationRule.ValidationRegexPattern : "";

        this.isValidPhone = true;
        if (validationRegex && validationRegex.length > 0) {
            var regexp = new RegExp(validationRegex, "i");
            this.isValidPhone = ValidationHelper.isExactMatch(newValue, regexp);
        }

        this.Model.Phone = newValue;
        this.phoneMasked = newMaskedValue;
    }

    public SetPublicPhone(newValue: string, newMaskedValue: string): void {
        // fetch Phon mask info
        let phoneValidationRule = this.GetPhoneValidationRule();
        let validationRegex: string = phoneValidationRule ? phoneValidationRule.ValidationRegexPattern : "";

        this.isPhonePublicValid = true;
        if (validationRegex && validationRegex.length > 0) {
            var regexp = new RegExp(validationRegex, "i");
            this.isPhonePublicValid = ValidationHelper.isExactMatch(newValue, regexp);
        }

        this.phonePublicMask = newMaskedValue;
        this.Model.PhonePublic = newValue;
    }

    public SetFax(newValue: string, newMaskedValue: string): void {
        // fetch Phon mask info
        let phoneValidationRule = this.GetPhoneValidationRule();
        let validationRegex: string = phoneValidationRule ? phoneValidationRule.ValidationRegexPattern : "";

        this.isFaxValid = true;
        if (newValue == null) {
            this.isFaxValid = false;
        }
        else if (validationRegex && validationRegex.length > 0) {
            var regexp = new RegExp(validationRegex, "i");
            this.isFaxValid = ValidationHelper.isExactMatch(newValue, regexp);
        }

        this.faxMasked = newMaskedValue;
        this.Model.Fax = newValue;
    }

    public SetPublicFax(newValue: string, newMaskedValue: string): void {
        // fetch Phon mask info
        let phoneValidationRule = this.GetPhoneValidationRule();
        let validationRegex: string = phoneValidationRule ? phoneValidationRule.ValidationRegexPattern : "";

        this.isFaxPublicValid = true;
        if (validationRegex && validationRegex.length > 0) {
            var regexp = new RegExp(validationRegex, "i");
            this.isFaxPublicValid = ValidationHelper.isExactMatch(newValue, regexp);
        }

        this.faxPublicMask = newMaskedValue;
        this.Model.FaxPublic = newValue;
    }

    public GetPhoneValidationRule(): any {
        return (this.countryMyleLookupId.length > 0) ? cacheStore.validationHelper.getPhoneNumberValidationRule(this.countryMyleLookupId, null) : cacheStore.validationHelper.getPhoneNumberValidationRule(cacheStore.SiteCache[0].Model.Adresses[0].CountryLookupId, null);
    }

    public GetZipCodeValidationRule(): any {
        return (this.countryMyleLookupId.length > 0) ? cacheStore.validationHelper.getPostalCodeValidationRule(this.countryMyleLookupId, null) : cacheStore.validationHelper.getPostalCodeValidationRule(cacheStore.SiteCache[0].Model.Adresses[0].CountryLookupId, null);
    }

    public GetEmailValidationRule(): any {
        return cacheStore.validationHelper.getEmailValidationRule();
    }

    public emailValidation(newValue: string): void {
        this.isEmailValid = true;
        this.isEmailValid = ValidationHelper.isExactMatch(newValue, ValidationHelper.emailRegex);
    }

    public getAddress(): string {
        return [
            this.Model.Address + (!IsNullOrWhiteSpace(this.Model.RegionNumber?.toString()?.trim()) ? ` - Reg ${this.Model.RegionNumber}` : ""),
            this.Model.City,
            cacheStore.GetLookupById(this.provinceMyleLookupId)?.GetValue?.(),
            this.Model.PostalCode
        ]
            .filter(p => !!p)
            .join(", ");
    }
}

export { LabFacilityModel };
